var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntensity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10083_11156)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#002C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7714 26.7429C39.7714 18.0325 32.7103 10.9714 23.9999 10.9714C15.2896 10.9714 8.22852 18.0325 8.22852 26.7429H39.7714Z",
    fill: "#004271"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6443 20.4962C33.5771 18.6913 32.0734 17.1806 30.2806 16.1131L31.9707 13.1537C34.2763 14.5215 36.2076 16.4644 37.5718 18.7876L34.6443 20.4962ZM34.8148 20.7936C35.7934 22.557 36.3623 24.584 36.391 26.7428H39.7705C39.7416 23.9617 39.0082 21.3512 37.7422 19.0851L34.8148 20.7936ZM29.9836 15.9418L31.674 12.982C29.4493 11.7271 26.893 11.0008 24.1713 10.9714V14.3885C26.2773 14.4173 28.2564 14.9772 29.9836 15.9418ZM15.9701 13.1884C13.6868 14.5562 11.7742 16.4898 10.4211 18.798L13.3492 20.5069C14.4051 18.7171 15.89 17.2159 17.6605 16.1483L15.9701 13.1884ZM13.179 20.8046L10.2509 19.0957C8.98855 21.3593 8.2574 23.966 8.22852 26.7428H11.6089C11.6375 24.5884 12.204 22.5653 13.179 20.8046ZM17.9565 15.9753L16.2662 13.0154C18.5048 11.7398 21.0825 11.0009 23.8285 10.9714V14.3885C21.6982 14.4177 19.6977 14.9903 17.9565 15.9753Z",
    fill: "url(#paint0_linear_10083_11156)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5415 18.8522C27.1942 18.7012 26.7903 18.8604 26.6393 19.2078L24.2522 24.701C24.1694 24.6909 24.0851 24.6857 23.9995 24.6857C22.8634 24.6857 21.9424 25.6067 21.9424 26.7428C21.9424 27.8789 22.8634 28.8 23.9995 28.8C25.1357 28.8 26.0567 27.8789 26.0567 26.7428C26.0567 26.1883 25.8373 25.6851 25.4806 25.3152L27.8971 19.7543C28.0481 19.407 27.8888 19.0031 27.5415 18.8522Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10083_11156",
    x1: 10.2401,
    y1: 25.2063,
    x2: 38.403,
    y2: 25.2063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138146,
    stopColor: "#50AAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.240682,
    stopColor: "#62BEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.340776,
    stopColor: "#8DCB8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472607,
    stopColor: "#F0DB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619087,
    stopColor: "#F1B26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73627,
    stopColor: "#EF8766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86566,
    stopColor: "#EE7962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8625A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10083_11156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntensity);
export default __webpack_public_path__ + "static/media/intensity.d4d937f73f6f01ef1ca0af3a881cf9b2.svg";
export { ForwardRef as ReactComponent };